export default {
  headerContent: {
    title: 'Türk Nippon Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Türk Nippon Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası, bireyin yurt içi veya yurt dışına iş, öğrenim veya tatil gibi nedenlerle yapmayı planladığı seyahatlere karşı teminat sunan sigorta ürünüdür. ',
        'Seyahat sigortası, kayıp bagaj ve seyahat iptali dâhil olmak üzere bir seyahatteki finansal yatırımı korur.',
        'Seçtiğiniz sigorta planına ve poliçe türüne bağlı tipik bir seyahat sigortası planı, seyahat edenlerin tüm temel endişelerini kapsayacaktır. Standart seyahat sigortası, genellikle seyahat iptalleri, seyahat gecikmeleri, tıbbi acil durumlar, kayıp bagaj gibi durumları kapsar.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Seyahat Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: '',
          subList: [
            'Acil mesajların iletilmesi',
            'Aile üyelerinden birinin ölümü nedeniyle yolculuğun durdurulması sonucu geri dönüş seyahati',
            'Bagajın bulunması ve sigortalıya ulaştırılması',
            'Evde meydana gelen hasar nedeniyle yolculuğun durdurulması sonucu geri dönüş seyahati',
            'Gecikmeli bagaj teminatı',
            'İlaç gönderilmesi organizasyonu',
            'Kanuni işlemlerle ilgili kefalet',
            'Sigortalıya yapılacak tedavi nedeniyle aile üyelerinden birinin konaklaması',
            'Taburcu olduktan sonra daimi ikametgaha nakil',
            'Tarifeli bagaj kaybı, zarar görmesi, çalınması',
            'Vefat eden sigortalının nakli',
            'Yaralanma veya hastalık nedeniyle sigortalının nakli',
            'Yaralanma veya hastalık nedeniyle tıbbi tedavi teminatı seyahat sağlık sigortası teminatları arasında yer almaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türk Nippon Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
